import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { hasFeatureEnabled } from '../../../services/feature';
import { ACCESS_AUTHENTICATED } from '../../../services/route/permissions';
import { fetchFollowsForCurrentMember } from '../../../services/store/modules/follows';
import {
  fetchLoggedInMembersPositions,
  getSharedSignalsWithCurrentMember,
} from '../../../services/store/modules/signal';
import AuthCheck from '../../helpers/AuthCheck/AuthCheck';
import CommunityPage from './CommunityPage/CommunityPage';
import FindFriendsToFollowPage from './FindFriendsToFollowPage/FindFriendsToFollowPage';
import FriendsPage from './FriendsPage/FriendsPage';
import GroupPage from './GroupPage/GroupPage';
import GroupsListPage from './GroupsListPage/GroupsListPage';
import SafetyContactsPage from './SafetyContactsPage/SafetyContactsPage';
import SignalAddSharedUsersPage from './SignalAddSharedUsersPage/SignalAddSharedUsersPage';
import SignalHomePage from './SignalHomePage/SignalHomePage';
import SignalMarkerSheet from './SignalMarkerSheet/SignalMarkerSheet';

const SignalFeature: FC = () => {
  const { path } = useRouteMatch();

  const dispatch = useDispatch();
  const defaultGroup = useSelector(
    (state: any) => state.appControls?.memberSettings?.groups?.defaultGroup,
  );

  useEffect(() => {
    dispatch(fetchLoggedInMembersPositions());
    dispatch(getSharedSignalsWithCurrentMember());
    dispatch(fetchFollowsForCurrentMember());
  }, [dispatch]);

  return (
    <Switch>
      <Route path="/maps/signal/following" exact>
        <Redirect to="/maps/signal/friends-sheet" />
      </Route>
      <Route path="/maps/signal/friends-sheet" exact>
        {hasFeatureEnabled('groups') ? (
          <Redirect
            to={
              defaultGroup
                ? `/maps/signal/groups/${defaultGroup}`
                : '/maps/signal/groups/community'
            }
          />
        ) : (
          <FriendsPage />
        )}
      </Route>
      <Route path="/maps/signal" exact>
        <Redirect to={`${path}/you`} />
      </Route>
      <Route path={`${path}/:pagename(you|following)`} exact>
        <SignalHomePage />
      </Route>
      <Route path={`${path}/find-friends-to-follow`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <FindFriendsToFollowPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/search`}>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <SignalAddSharedUsersPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/groups`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <GroupsListPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/groups/safety-contacts`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <SafetyContactsPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/groups/community`} exact>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <CommunityPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/groups/:id`}>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <GroupPage />
        </AuthCheck>
      </Route>
      <Route path={`${path}/:id`}>
        <AuthCheck authentication={ACCESS_AUTHENTICATED}>
          <SignalMarkerSheet />
        </AuthCheck>
      </Route>
    </Switch>
  );
};

export default SignalFeature;
